import React, { Component } from 'react';
import { Form, Grid, Button } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import { InputField } from 'Common/SemanticWrapper';
import { IPRANGE_ENTRY_FORM_NAME } from 'Common/FormEnum';
import { IPRangeFieldEnum } from 'Common/FieldEnum';
import { StyledReduxFormError } from 'Components/';

class IPRangeEntryFormContainer extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
    onMyIPRequest: PropTypes.func,
    MyIPDisabled: PropTypes.bool,
    initialValues: PropTypes.object,
  };

  static defaultProps = {};

  render() {
    const { handleSubmit, error, onMyIPRequest, myIPDisabled } = this.props;

    return (
      <Form onSubmit={handleSubmit}>
        <Grid columns={4}>
          <Field name={IPRangeFieldEnum.Id} component="input" type="hidden" />

          <Grid.Row>
            <Grid.Column>
              <Field
                type="text"
                name={IPRangeFieldEnum.Description}
                component={InputField}
                label="Description"
                maxLength={50}
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                type="text"
                name={IPRangeFieldEnum.LowerRange}
                component={InputField}
                label="Range Start"
                maxLength={45}
                required
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                type="text"
                name={IPRangeFieldEnum.UpperRange}
                component={InputField}
                label="Range End"
                maxLength={45}
              />
            </Grid.Column>

            <Grid.Column>
              <div className="field">
                <label>&nbsp;</label>

                <Button
                  type="button"
                  content="Use My IP"
                  onClick={() => onMyIPRequest()}
                  disabled={myIPDisabled}
                  style={{ width: '100%' }}
                />
              </div>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              <StyledReduxFormError error={error} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

const validate = values => {
  const errors = {};

  if (!values[IPRangeFieldEnum.LowerRange]) {
    errors[IPRangeFieldEnum.LowerRange] = 'Range Start is required.';
  }

  return errors;
};

export const IPRangeEntryForm = reduxForm({
  form: IPRANGE_ENTRY_FORM_NAME,
  validate,
})(IPRangeEntryFormContainer);



// WEBPACK FOOTER //
// ./src/pages/networkfiltering/components/IPRangeEntryForm.js